import {
  PencilIcon,
  ArrowLeftEndOnRectangleIcon,
} from "@heroicons/react/20/solid";

import { AuthContext } from "../context/AuthContext";
import useAxios from "../utils/useAxios";
import { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";

// Agregar estilos CSS personalizados
const customStyles = `
  <style>
    .custom-validation-message {
      color: #dc2626 !important;
      background-color: #fef2f2 !important;
      border: 1px solid #fecaca !important;
      border-radius: 0.375rem !important;
      padding: 0.5rem !important;
      margin-top: 0.5rem !important;
    }
    .custom-password-input {
      width: 100% !important;
      margin: 0.25rem 0 !important;
      padding: 0.75rem !important;
      border: 2px solid #e5e7eb !important;
      border-radius: 0.5rem !important;
      font-size: 0.875rem !important;
      transition: all 0.2s ease-in-out !important;
      background-color: #ffffff !important;
      color: #374151 !important;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
    }
    .custom-password-input:focus {
      outline: none !important;
      border-color: #4f46e5 !important;
      box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1) !important;
    }
    .custom-password-input:hover {
      border-color: #9ca3af !important;
    }
    .custom-password-input::placeholder {
      color: #9ca3af !important;
    }
    .password-container {
      text-align: left !important;
      margin-bottom: 1rem !important;
    }
    .password-label {
      display: block !important;
      font-size: 0.875rem !important;
      font-weight: 500 !important;
      color: #374151 !important;
      margin-bottom: 0.375rem !important;
      text-align: left !important;
    }
  </style>
`;



function HeadComponent() {

  const { user, logoutUser, userMeData, changePassUser } = useContext(AuthContext);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  // Función para procesar errores del servidor
  const processServerErrors = (response) => {
    const errors = response.errors || response;
    
    if (!errors || typeof errors !== 'object') {
      return 'Error desconocido';
    }

    let errorHtml = '<ul style="margin: 0; padding-left: 20px;">';
    
    Object.keys(errors).forEach(field => {
      const fieldErrors = errors[field];
      if (Array.isArray(fieldErrors)) {
        fieldErrors.forEach(error => {
          errorHtml += `<li style="margin-bottom: 8px; color: #dc2626;">${error}</li>`;
        });
      } else if (typeof fieldErrors === 'string') {
        errorHtml += `<li style="margin-bottom: 8px; color: #dc2626;">${fieldErrors}</li>`;
      }
    });
    
    errorHtml += '</ul>';
    return errorHtml;
  };

  const cambiarContrasena = async () => {
    const { value: formValues } = await Swal.fire({
      title: 'Cambiar Contraseña',
      background: "white",
      color: "black",
      html: `
        ${customStyles}
        <div style="padding: 1rem 0;">
          <div class="password-container">
            <label class="password-label">Contraseña Actual</label>
            <input id="swal-input1" type="password" class="custom-password-input" placeholder="Ingrese su contraseña actual">
          </div>
          <div class="password-container">
            <label class="password-label">Nueva Contraseña</label>
            <input id="swal-input2" type="password" class="custom-password-input" placeholder="Ingrese su nueva contraseña">
          </div>
          <div class="password-container">
            <label class="password-label">Confirmar Contraseña</label>
            <input id="swal-input3" type="password" class="custom-password-input" placeholder="Confirme su nueva contraseña">
          </div>
        </div>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Cambiar Contraseña',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#4f46e5',
      customClass: {
        validationMessage: 'custom-validation-message'
      },
      preConfirm: () => {
        const currentPassword = document.getElementById('swal-input1').value;
        const newPassword = document.getElementById('swal-input2').value;
        const confirmPassword = document.getElementById('swal-input3').value;

        if (!currentPassword || !newPassword || !confirmPassword) {
          Swal.showValidationMessage('Todos los campos son obligatorios');
          return false;
        }

        if (newPassword !== confirmPassword) {
          Swal.showValidationMessage('Las nuevas contraseñas no coinciden');
          return false;
        }

        if (newPassword.length < 6) {
          Swal.showValidationMessage('La nueva contraseña debe tener al menos 6 caracteres');
          return false;
        }

        return {
          currentPassword: currentPassword,
          newPassword: newPassword,
          confirmPassword: confirmPassword
        };
      }
    });

    if (formValues) {
      // Aquí puedes agregar la lógica para enviar los datos al servidor
      try {
        Swal.fire({
          title: 'Procesando...',
          text: 'Cambiando contraseña...',
          background: "white",
          color: "black",
          icon: 'info',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const response = await changePassUser(
          formValues.newPassword,
          formValues.confirmPassword,
          formValues.currentPassword
        );

        if (response.success) {
          Swal.fire({
            title: '¡Éxito!',
            background: "white",
            color: "black",
            text: 'Contraseña cambiada correctamente',
            icon: 'success',
            confirmButtonText: 'Entendido'
          });
        } else {
          // Si hay errores específicos del servidor, los procesamos
          const errorMessages = processServerErrors(response);
          
          const errorResult = await Swal.fire({
            title: 'Error al cambiar contraseña',
            background: "white",
            color: "black",
            html: `<div style="text-align: left;">${errorMessages}</div>`,
            icon: 'error',
            confirmButtonText: 'Intentar de nuevo',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            width: '500px'
          });

          // Si el usuario hace clic en "Intentar de nuevo", volvemos al formulario
          if (errorResult.isConfirmed) {
            // Llamamos recursivamente a la función para mostrar el formulario de nuevo
            await cambiarContrasena();
          }
        }

      } catch (error) {
        console.error('Error inesperado:', error);
        const errorResult = await Swal.fire({
          title: 'Error',
          background: "white",
          color: "black",
          text: 'Ocurrió un error inesperado. Inténtelo nuevamente.',
          icon: 'error',
          confirmButtonText: 'Intentar de nuevo',
          showCancelButton: true,
          cancelButtonText: 'Cancelar'
        });

        // Si el usuario hace clic en "Intentar de nuevo", volvemos al formulario
        if (errorResult.isConfirmed) {
          await cambiarContrasena();
        }
      }
    }
  }


  useEffect(() => {
    // Función para realizar la solicitud de información del usuario
    const fetchUserInfo = async () => {
      try {
        // Reemplaza la URL con la URL de tu servicio
        const data = await userMeData();
        setUserInfo(data);
        setLoading(false);
      } catch (error) {
        console.error('Error al obtener la información del usuario', error);
        setLoading(false);
      }
    };

    // Llama a la función para realizar la solicitud al montar el componente
    fetchUserInfo();
  }, []); // El segundo parámetro [] garantiza que useEffect se ejecute solo una vez al montar el componente



  return (
    <header className="bg-white shadow">
      <div className="pl-5 pr-5 pt-3 pb-3 lg:flex lg:items-center lg:justify-between">
        <div className="min-w-0 flex-1">
          <h2 className="text-2xl font-extralight leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            Facturación electrónica
          </h2>
          <div className="mt-2 flex flex-col space-y-2 sm:mt-1 sm:space-y-1">
            <div className="flex flex-wrap items-center gap-1 text-sm text-gray-500">
              <span>Hola</span>
              {loading ? (
                <span className="font-bold">...</span>
              ) : (
                <span className="font-bold">
                  {userInfo?.first_name} - {userInfo?.vat}
                </span>
              )}
            </div>
            <div className="text-sm text-gray-500">
              <span>Bienvenido a la plataforma de facturación electrónica de </span>
              <a 
                href="https://www.elipsys.ec" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-bold text-blue-600 hover:text-blue-800 transition-colors duration-200"
              >
                Elipsys
              </a>
            </div>
          </div>
        </div>
        <div className="mt-5 flex flex-col gap-3 sm:flex-row lg:ml-4 lg:mt-0">
          <button
            type="button"
            onClick={cambiarContrasena}
            className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 w-full sm:w-auto"
          >
            <PencilIcon
              className="-ml-0.5 mr-1.5 h-4 w-4 sm:h-5 sm:w-5 text-gray-400"
              aria-hidden="true"
            />
            <span className="sm:inline">Modificar mi contraseña</span>
          </button>

          <button
            onClick={logoutUser}
            type="button"
            className="inline-flex items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 w-full sm:w-auto"
          >
            <ArrowLeftEndOnRectangleIcon
              className="-ml-0.5 mr-1.5 h-4 w-4 sm:h-5 sm:w-5"
              aria-hidden="true"
            />
            Salir
          </button>
        </div>
      </div>
    </header>
  );
}

export default HeadComponent;
